import type {
    CompatibilityProfile,
    CompatibilityResult,
} from "../../compatibility/types.ts";
import {
    type CompatibilityListingInput,
    extractAdoptionRequirements,
} from "../../compatibility/requirements.ts";
import { scoreCompatibility } from "./score.ts";

export function evaluateListingCompatibility(
    listing: CompatibilityListingInput,
    profile: CompatibilityProfile,
): CompatibilityResult {
    return scoreCompatibility({
        requirements: extractAdoptionRequirements(listing),
        profile,
        listingName: listing.name,
        organizationName: listing.organizationName,
        organizationState: listing.organizationState,
    });
}
